var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqualHousingLenderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 72.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.19,
    y: 30.28,
    width: 36.7,
    height: 9.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.19,
    y: 44.95,
    width: 36.7,
    height: 9.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.46,0L0,24.77v12.84l3.67-1.8v36.66h91.74v-37.99l4.59,2.21v-12.84L50.46,0Zm33.94,63.3H14.68V30.41L50.46,12.84l33.94,16.34v34.11Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualHousingLenderIcon);
export default __webpack_public_path__ + "static/media/EqualHousingLenderIcon.c9de7c597490ea1d666bc557a59298c2.svg";
export { ForwardRef as ReactComponent };